const ImageForm = {
  mounted() {
    console.log('ImageForm mounted')
    const thisEl = (this as any).el

    const dataset = thisEl.dataset

    const imageInput = dataset.imageFileInput
      ? thisEl.elements[dataset.imageFileInput]
      : thisEl.elements['image']

    const widthInput = dataset.imageWidthInput
      ? thisEl.elements[dataset.imageWidthInput]
      : thisEl.elements['image[width]']

    const heightInput = dataset.imageHeightInput
      ? thisEl.elements[dataset.imageHeightInput]
      : thisEl.elements['image[height]']

    if (!imageInput) {
      throw new Error('Image input not found')
    }

    if (!widthInput) {
      throw new Error('Width input not found')
    }

    if (!heightInput) {
      throw new Error('Height input not found')
    }

    imageInput.addEventListener('change', async () => {
      const file = imageInput.files[0]

      if (!file) {
        return
      }

      const img = new Image()
      img.src = URL.createObjectURL(file)
      await img.decode()
      const width = img.width
      const height = img.height

      widthInput.value = width.toString()
      heightInput.value = height.toString()

      console.log('width', width)
      console.log('height', height)

      widthInput.dispatchEvent(new CustomEvent('change', { bubbles: true }))
    })
  },
}
export { ImageForm }
